// extracted by mini-css-extract-plugin
module.exports = {"Map":"map_Map__3SviN","US_map":"map_US_map__2uir0","frame":"map_frame__2Tr1b"};